import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Button, Logo, Tabs } from '../../design-system';
import { useAuth } from '../../features/auth/useAuth';
import styles from './Layout.module.css';

const TAB_TO_PATH: Record<string, string> = {
  dash: '/',
  fleet: '/wagenpark',
  personen: '/personen',
  passen: '/passen',
  inv: '/facturen',
};

// Longest-prefix match so /personen/:id still highlights the Personen tab. The
// car archive (/archief) lives under the Wagenpark tab (reached via a button).
function tabForPath(path: string): string {
  if (path === '/') return 'dash';
  if (path.startsWith('/wagenpark') || path.startsWith('/archief')) return 'fleet';
  if (path.startsWith('/personen')) return 'personen';
  if (path.startsWith('/passen')) return 'passen';
  if (path.startsWith('/facturen')) return 'inv';
  return 'dash';
}

const today = new Date().toLocaleDateString('nl-NL', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const activeTab = tabForPath(location.pathname);
  const tabItems = [
    { id: 'dash', label: 'Dashboard' },
    { id: 'fleet', label: 'Wagenpark' },
    { id: 'personen', label: 'Personen' },
    { id: 'passen', label: 'Passen' },
    { id: 'inv', label: 'Facturen' },
  ];

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header className={styles.header}>
        <div className={styles.topRow}>
          <div className={styles.brand}>
            <Logo height={28} />
            <div className={styles.divider} />
            <div className={styles.eyebrow}>Wagenpark</div>
          </div>
          <div className={styles.right}>
            <span className={styles.date}>{today}</span>
            <Button variant="ghost" size="sm" onClick={() => navigate('/instellingen')}>
              Instellingen
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={async () => {
                await logout();
                navigate('/login');
              }}
            >
              Uitloggen
            </Button>
          </div>
        </div>
        <div className={styles.tabsRow}>
          <Tabs
            items={tabItems}
            value={activeTab}
            onChange={(id) => navigate(TAB_TO_PATH[id] ?? '/')}
          />
        </div>
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
